export default __webpack_public_path__ + "static/17_dixit-df12de741c27f212f52e6d0fc352ff3c.png";